module.exports = __webpack_public_path__ + "static/mask1-7b38884bb5d75136667f3593986de06e.png";